const hBusBootstrapper = {
  init() {
    window.project_version = process.env.APP_BUILD_VERSION || '1.00';
  },
};

export default hBusBootstrapper;
